import { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { any } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import dialog from 'features/common/dialog';
import fetch from 'features/common/fetch';
import campaignAdditionalData from 'features/views/campaignSettings/additionalData';

import DragContainer from './components/DragContainer';

export const CampaignAdditionalData = ({ campaignId }) => {
	const dispatch = useDispatch();

	const activeData = useSelector(campaignAdditionalData.selectors.getActiveData);

	useEffect(() => {
		dispatch(campaignAdditionalData.actions.fetchCampaignAdditionalData(campaignId));
		//eslint-disable-next-line
	}, [dispatch]);

	const handleSaveData = useCallback(() => {
		const isAnyoneWithoutDescription = any((item) => item.description === '');

		if (isAnyoneWithoutDescription(activeData)) {
			dispatch(dialog.actions.open(campaignAdditionalData.constants.NO_DESCRIPTION_ERROR));
		} else {
			dispatch(dialog.actions.close(campaignAdditionalData.constants.NO_DESCRIPTION_ERROR));
			dispatch(campaignAdditionalData.actions.saveCampaignAdditionalData(campaignId, activeData));
		}
	}, [dispatch, activeData, campaignId]);

	const handleRemove = useCallback(
		(key) => {
			dispatch(campaignAdditionalData.actions.discardData(key));
		},
		[dispatch],
	);

	const handleTextChange = useCallback(
		(key, text) => {
			dispatch(campaignAdditionalData.actions.editData(key, text));
		},
		[dispatch],
	);

	const handleReorder = useCallback(
		(key, data) => {
			dispatch(campaignAdditionalData.actions.updateData(key, data));
		},
		[dispatch],
	);

	return (
		<Paper sx={{ p: 3, borderRadius: 2 }}>
			<SectionHeader sx={{ mb: 2 }} text={getLabelMessage('campaignAdditionalData:addedDataForUser')} />
			<Grid container>
				<Grid size={12}>
					<Grid container spacing={5}>
						<Grid size={12}>
							<ComponentLoader fetchStorePath={fetch.constants.urls.campaignAdditionalData}>
								<DragContainer
									items={activeData}
									onRemove={handleRemove}
									onTextChange={handleTextChange}
									onReorder={handleReorder}
								/>
							</ComponentLoader>
						</Grid>
						<Grid size={4} />
						<Grid size={4}>
							<Button fullWidth variant="contained" onClick={handleSaveData}>
								{getLabelMessage('common:save')}
							</Button>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Paper>
	);
};

CampaignAdditionalData.propTypes = {
	campaignId: PropTypes.number,
};

export default CampaignAdditionalData;
